import { Cart } from '../components/Cart/Cart';
import { PublicLayout } from '../layout/PublicLayout';
import ScrollToTop from "react-scroll-to-top";

const breadcrumbsData = [
  {
    label: 'Home',
    path: '/',
  },
  {
    label: 'Cart',
    path: '/cart',
  },
];
const CartPage = () => {
  return (
    <PublicLayout breadcrumb={breadcrumbsData} breadcrumbTitle='Cart'>
      <Cart />
      <ScrollToTop smooth />
    </PublicLayout>
  );
};

export default CartPage;
